import { render } from "./circleCom.vue?vue&type=template&id=abc8407c&scoped=true&ts=true"
import script from "./circleCom.vue?vue&type=script&lang=ts"
export * from "./circleCom.vue?vue&type=script&lang=ts"

import "./circleCom.vue?vue&type=style&index=0&id=abc8407c&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc8407c"]])

export default __exports__